import React from 'react'






const Border = (props) => (

	<div className="border">
   		<div className="top"></div>
		<div className="bottom"></div>
		<div className="left"></div>
		<div className="right"></div>
   	</div>
)

export default Border


// WEBPACK FOOTER //
// ./src/components/border.js